import React from 'react';
import Listingheader from '../../../../home/components/common/ListingheaderV2';
import TopicMovieReviewCard from '../TopicMovieReviewCard';
import s from './Filmography.scss';

function Filmography({
  data,
  headline,
  classname,
  viewMore,
  loadMoreTabData,
  hideMoreFilmography,
}) {
  if (!data || !data.length) {
    return null;
  }

  return (
    <div className={s.filmography}>
      {headline && (
        <Listingheader headingname={headline} overrideClass={s.topicheading} />
      )}
      <div className={`movie_card ${classname}`}>
        {Array.isArray(data) && data.length > 0
          ? data.map((el, idx) => <TopicMovieReviewCard key={idx} data={el} />)
          : null}
        {typeof viewMore === 'function' && (
          <button
            className={s.morebtn}
            onClick={() => viewMore('filmography', true)}
          >
            More Fimography Results
          </button>
        )}
      </div>
      {typeof loadMoreTabData === 'function' &&
        !hideMoreFilmography && (
          <div className={`${s.loadMore}`}>
            <button
              type="button"
              onClick={() => loadMoreTabData('filmography')}
            >
              Load More
            </button>
          </div>
        )}
    </div>
  );
}

export default Filmography;
